/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UserAddDTO.ts
 */

import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {UserResetPasswordDTO} from "../../dto/user/UserResetPasswordDTO";
import {TextField} from "../../../tools/model/form/TextField";
import Translation from "../../../services/translation/Translation";
import {isAnEmail} from "../../../tools/utils/Utils";
import {Type} from "../../../tools/view/form/FormInput";
import User from "../../User";

export default class UserResetPasswordForm extends AbstractForm<UserResetPasswordDTO> {
    constructor(user: User) {
        super();

        this.fields.set(UserResetPasswordDTO.EMAIL, new TextField(
            UserResetPasswordDTO.EMAIL,
            (t: Translation) => t.loginFormMailPh,
            value => typeof value === "string" && isAnEmail(value),
            Type.EMAIL,
            true,
            "",
            "",
            true
        ));

        this.load(UserResetPasswordDTO.fromUser(user));
    }
}
